<template>
  <v-layout align-center>
    <v-flex xs12 sm10 md8>
      <v-layout wrap>
        <v-flex xs12>
          <form v-scroll-to-error @submit.prevent="submitForm">
            <div class="screen-title mb-0">
              <span>Create Announcement</span>
            </div>
            <div class="mb-32 title-description">
              You need to provide information about your new announcement.
            </div>
            <announcement-form
              :vs="$v"
              :initial-values="form"
              @values="form=$event"
            />
            <main-button
              text="Create"
              depressed
              :loading="loading"
              @click="$emit('submit')"
            />
            <main-button
              text="Cancel"
              flat
              @click.prevent="goBack"
            />
          </form>
        </v-flex>
      </v-layout>
    </v-flex>
    <error-snackbar
      :open.sync="showErrorSnackbar"
      title="Oops"
      message="Something went wrong..."
    />
  </v-layout>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

import ErrorSnackbar from '../shared/snackbars/errors-snackbar'
import AnnouncementForm from './announcement-form.vue'
import MainButton from './../shared/main-button.vue'
import {createAnnouncement} from './../../http'
import { submitGuard } from './../../utils'

export default {
  name: 'new-announcement-container',
  components: {
    AnnouncementForm,
    MainButton,
    ErrorSnackbar,
  },
  props: {
    eventId: {
      default: null,
      type: String,
    },
  },
  validations() {
    const component = this

    return {
      form: {
        title: { required },
        text: { required },
      },
    }
  },
  data: () => ({
    form: {},
    loading: false,
    showErrorSnackbar: false,
  }),
  methods:{
    async submitForm() {
      await submitGuard(this, async () =>{
        const setLoading = setTimeout(() => this.loading = true, 500)
        const { errors } = await createAnnouncement(this.eventId, this.form)

        if (!this.loading) clearTimeout(setLoading)

        if (!errors) return this.goBack()

        this.showErrorSnackbar = true
        this.loading = false
      })
    },
  },
}
</script>

<style>
</style>
